import axiosInstance from "../api";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";

export const checkMembershipPermissions = (posttype, masterID) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `membership/check?page=${posttype}&master_id=${masterID ?? ""}`,
    );
    if (response?.data?.status) {
      return response?.data?.response;
    } else {
      return response?.data?.response;
    }
  } catch (error) {
    urtoast(error.message, 2);
  }
};
